import React from 'react';
import styles from './Text.module.css';

export interface TextProps {
  as?: 'p' | 'span' | 'div';
  children: React.ReactNode;
  className?: string;
  size?: 'xs' | 'sm' | 'base' | 'lg' | 'xl' | 'md';
  color?: 'primary' | 'secondary' | 'tertiary' | 'accent';
  weight?: 'normal' | 'medium' | 'semibold' | 'bold';
}

/**
 * Text Component
 * Consistent text styling
 */
export function Text({
  as: Component = 'p',
  children,
  className = '',
  size = 'base',
  color = 'secondary',
  weight = 'normal',
}: TextProps) {
  const classNames = [
    styles.text,
    styles[`size-${size}`],
    styles[`color-${color}`],
    styles[`weight-${weight}`],
    className,
  ].filter(Boolean).join(' ');

  return <Component className={classNames}>{children}</Component>;
}
